/**
 * D-180: while an occasion runs (and the player keeps occasion looks on), a thin strip of small triangle flags in its
 * bunting colours hangs along the very top of the tab pages, just under the safe area. Purely decorative. The colours
 * come from the occasion's data (checked #RRGGBB in lib/occasions.ts), not from this file.
 */
import { useId, type ReactElement } from "react";
import { liveOccasion, useOccasionsTick } from "../lib/occasions";

const FLAG_W = 14, FLAG_H = 11, GAP = 4;

export function BuntingStrip({ colours }: { colours: string[] }): ReactElement | null {
  const id = useId().replace(/:/g, "");
  if (colours.length === 0) return null;
  const step = FLAG_W + GAP, w = step * colours.length;
  return (
    <div className="occ-bunting" aria-hidden="true" data-testid="occasion-bunting">
      <svg width="100%" height={FLAG_H + 3} focusable="false">
        <defs>
          <pattern id={`bunting-${id}`} width={w} height={FLAG_H + 3} patternUnits="userSpaceOnUse">
            {colours.map((c, i) => <polygon key={i} points={`${i * step + GAP / 2},2 ${i * step + GAP / 2 + FLAG_W},2 ${i * step + GAP / 2 + FLAG_W / 2},${FLAG_H + 2}`} fill={c} data-colour={c} />)}
          </pattern>
        </defs>
        <line x1="0" y1="1.5" x2="100%" y2="1.5" className="occ-bunting__string" />
        <rect x="0" y="0" width="100%" height={FLAG_H + 3} fill={`url(#bunting-${id})`} />
      </svg>
    </div>
  );
}

/** The current occasion's bunting, or nothing. `on` is prefs.occasionLooks. */
export function Bunting({ on }: { on: boolean | undefined }): ReactElement | null {
  useOccasionsTick();
  const occ = liveOccasion(on);
  return occ ? <BuntingStrip colours={occ.look.bunting} /> : null;
}
